import { useEffect, useRef, useState } from "react";

export default function useFinanceModalState({ isMobile }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showBudgetModal, setShowBudgetModal] = useState(false);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    date: "",
    type: "지출",
    category: "식비",
    amount: "",
    description: "",
  });

  const [modalPos, setModalPos] = useState({ x: 0, y: 0 });
  const isDraggingRef = useRef(false);
  const dragStartRef = useRef({ x: 0, y: 0 });

  const [excelModalPos, setExcelModalPos] = useState({ x: 0, y: 0 });
  const isExcelDraggingRef = useRef(false);
  const excelDragStartRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (isModalOpen) {
      setModalPos({ x: 0, y: 0 });
    }
  }, [isModalOpen]);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDraggingRef.current) return;
      e.preventDefault();
      const dx = e.clientX - dragStartRef.current.startX;
      const dy = e.clientY - dragStartRef.current.startY;
      setModalPos({
        x: dragStartRef.current.initialX + dx,
        y: dragStartRef.current.initialY + dy,
      });
    };

    const handleMouseUp = () => {
      isDraggingRef.current = false;
    };

    if (isModalOpen) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isModalOpen]);

  const handleHeaderMouseDown = (e) => {
    if (isMobile) return;
    isDraggingRef.current = true;
    dragStartRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      initialX: modalPos.x,
      initialY: modalPos.y,
    };
  };

  useEffect(() => {
    const handleExcelMouseMove = (e) => {
      if (!isExcelDraggingRef.current) return;
      e.preventDefault();
      const dx = e.clientX - excelDragStartRef.current.startX;
      const dy = e.clientY - excelDragStartRef.current.startY;
      setExcelModalPos({
        x: excelDragStartRef.current.initialX + dx,
        y: excelDragStartRef.current.initialY + dy,
      });
    };

    const handleExcelMouseUp = () => {
      isExcelDraggingRef.current = false;
    };

    if (showExcelModal) {
      window.addEventListener("mousemove", handleExcelMouseMove);
      window.addEventListener("mouseup", handleExcelMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleExcelMouseMove);
      window.removeEventListener("mouseup", handleExcelMouseUp);
    };
  }, [showExcelModal]);

  useEffect(() => {
    if (showExcelModal) {
      setExcelModalPos({ x: 0, y: 0 });
    }
  }, [showExcelModal]);

  const handleExcelHeaderMouseDown = (e) => {
    if (isMobile) return;
    isExcelDraggingRef.current = true;
    excelDragStartRef.current = {
      startX: e.clientX,
      startY: e.clientY,
      initialX: excelModalPos.x,
      initialY: excelModalPos.y,
    };
  };

  return {
    isModalOpen,
    setIsModalOpen,
    showBudgetModal,
    setShowBudgetModal,
    showExcelModal,
    setShowExcelModal,
    editingItem,
    setEditingItem,
    formData,
    setFormData,
    modalPos,
    isDraggingRef,
    handleHeaderMouseDown,
    excelModalPos,
    handleExcelHeaderMouseDown,
  };
}
